import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI, { Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/ja';
// -------↓Amplify 追加↓-------
import awsconfig from './backend.js';
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';

Amplify.configure(awsconfig);
Vue.use(AmplifyPlugin, AmplifyModules);
// ------↑ここまで↑-----

import store from '@/store'

Vue.config.productionTip = false;
Vue.use(ElementUI, {locale}, Loading)

new Vue({
  router,
  loading: Loading,
  store,
  render: h => h(App)
}).$mount('#app');